import { Component } from '@angular/core';

@Component({
  selector: 'app-historical-data',
  standalone: true,
  imports: [],
  templateUrl: './historical-data.component.html',
  styleUrl: './historical-data.component.scss'
})
export class HistoricalDataComponent {

}
